import styled from 'styled-components'
import { tokens } from '../../../assets/tokens'

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`

export const Info = styled.p`
  margin: 0;
  font-size: 14px;
  color: ${tokens.color.text.secondary};
`

export const Label = styled.label`
  display: inline-block;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${tokens.color.text.label};
`

export const Error = styled.p`
  margin: 6px 0 0;
  font-size: 12px;
  color: ${tokens.color.error.main};
`
